import { lazy } from 'react';
import { Terms } from 'src/compass/shared/util/terms';
import { TabListCustomerMaintenance } from 'src/compass/pages/utilities/CustomerMaintenancePage';
import { ICONS } from '../navigationIcons';
import { TabListToRouteList } from '../../util/TabListToRouteList';

const BasisPage = lazy(() => import('src/compass/pages/utilities/BasisPage'));
const DailyPasswordPage = lazy(() => import('src/compass/pages/utilities/DailyPasswordPage'));
const PipPage = lazy(() => import('src/compass/pages/utilities/PipPage'));
const ProprietaryAccountsPage = lazy(
  () => import('src/compass/pages/utilities/ProprietaryAccountsPage')
);
const PoManagementPage = lazy(() => import('src/compass/pages/utilities/PoManagementPage'));
const FeederIndexSetupPage = lazy(() => import('src/compass/pages/utilities/FeederIndexSetupPage'));
const CustomerMaintenancePage = lazy(() => import('src/compass/pages/utilities/CustomerMaintenancePage'));
const MarginCallsPage = lazy(() => import('src/compass/pages/utilities/MarginCallsPage'));
const ChromePluginAccountEditPage = lazy(() => import('src/compass/pages/utilities/ChromePluginAccountEditPage'));
const MessagesPage = lazy(() => import('src/compass/pages/utilities/MessagesPage'));
const MonthlyScoresPage = lazy(() => import('src/compass/pages/administration/MonthlyScoresPage'));
const TestEnvironmentsPage = lazy(() => import('src/compass/pages/utilities/TestEnvironmentsPage'));

export const UtilitiesMenu = [
  {
    menuTitle: 'Utilities',
    path: 'utilities',
    icon: ICONS.user,
    subMenus: [
      {
        title: 'Basis',
        path: 'basis',
        element: <BasisPage />,
        permission: 'UTILITIES_BASIS',
      },
      {
        title: 'Daily Password',
        path: 'dailypassword',
        element: <DailyPasswordPage />,
        permission: 'DAILY_PWD',
      },
      {
        title: `${Terms.Customer.label} Maintenance`,
        path: Terms.Customer.plural,
        element: <CustomerMaintenancePage />,
        permission: 'ENTITIES',
        children: TabListToRouteList(TabListCustomerMaintenance),
      },
      {
        title: 'Feeder Index Setup',
        path: 'feederindexsetup',
        element: <FeederIndexSetupPage />,
        permission: 'UTILITIES_FDR_IDX_SETUP',
      },
      {
        title: 'Margin Calls',
        path: 'margincalls',
        element: <MarginCallsPage />,
        permission: 'MARGIN_CALLS',
      },
      {
        title: 'Edit Account Call Group',
        path: 'margincalls/callgroup',
        element: <ChromePluginAccountEditPage />,
        permission: 'MARGIN_CALLS',
        hidden: true,
      },
      {
        title: 'Messages',
        path: 'message-dataset-columns',
        element: <MessagesPage />,
        permission: 'MESSAGES',
      },
      {
        title: 'Monthly Scores',
        path: 'monthlyscores',
        element: <MonthlyScoresPage />,
        permission: 'MONTHLY_SCORES',
      },
      {
        title: 'PIP',
        path: 'pip',
        element: <PipPage />,
        permission: 'UTILITIES_PIP',
      },
      {
        title: 'PO Management',
        path: 'pomanagement',
        element: <PoManagementPage />,
        permission: 'UTILITIES_PO_MGT',
      },
      {
        title: 'Proprietary Accounts',
        path: 'proprietaryaccounts',
        element: <ProprietaryAccountsPage />,
        permission: 'UTILITIES_PROPRIETARY',
      },
      {
        title: 'Test Environments',
        path: 'testenvironments',
        element: <TestEnvironmentsPage />,
        permission: 'TEST_ENVS',
      },
    ],
  },
];
